// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Delete: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 38" enableBackground="new 0 0 30 38" xmlSpace="preserve">
<g fill="currentColor">
	<path d="M2.5,33.58c0,2.29,1.88,4.17,4.17,4.17h16.67c2.29,0,4.17-1.88,4.17-4.17v-25h-25V33.58z"/>
	<polygon points="22.29,2.33 20.21,0.25 9.79,0.25 7.71,2.33 0.42,2.33 0.42,6.5 29.58,6.5 29.58,2.33 	"/>
</g>
</svg>;
};

export default React.memo(Delete);
